module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.novalide ? "v_radiogroup" : "v_radiogroup error"
  }, _vm._l((_vm.group), function(inp) {
    return _c('label', {
      class: inp.class
    }, [(inp.check == "checked") ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checked),
        expression: "checked"
      }],
      attrs: {
        "checked": "checked",
        "type": "radio",
        "name": inp.name
      },
      domProps: {
        "value": inp.value,
        "checked": _vm._q(_vm.checked, inp.value)
      },
      on: {
        "change": [function($event) {
          _vm.checked = inp.value
        }, _vm.noerror]
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checked),
        expression: "checked"
      }],
      attrs: {
        "type": "radio",
        "name": inp.name
      },
      domProps: {
        "value": inp.value,
        "checked": _vm._q(_vm.checked, inp.value)
      },
      on: {
        "change": [function($event) {
          _vm.checked = inp.value
        }, _vm.noerror]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "radioLook"
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(inp.text))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dcff248"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/elements/radiogroup.vue
// module id = 262
// module chunks = 38